import { LanguagePicker } from './LanguagePicker'
import { ThemeToggle } from './ThemeToggle'

/**
 * Floating bottom-right pair of viewport-wide preferences: language and
 * light/dark mode. Mounted once at the app root so it appears on every
 * screen — including login and forced password change — without each
 * page having to thread it through. Both controls work for anonymous
 * users; the language preference round-trips to the server only when a
 * session exists.
 */
export function PreferencesBar() {
  return (
    <div className="fixed bottom-4 right-4 z-40 flex items-center gap-2">
      <LanguagePicker />
      <ThemeToggle />
    </div>
  )
}
